<template>
	<div style="height: 100%">
		<div class="sa-flexbox" style="padding-bottom: 20px">
			<div class="sa-flexbox-header">
				<div style="padding: 10px">
					<div class="sa-dataanalysis-header">
						<h2 class="sa-dataanalysis-title">Modifica Risorsa Query</h2>
						<span class="sa-dataanalysis-id-badge">ID: {{ jsonData.id }}</span>
					</div>
				</div>
			</div>
			<div class="sa-flexbox-body">
				<div style="padding: 10px; max-height: 100%; overflow: auto">
					<b-row class="mb-3">
						<b-col md="8">
							<b-form-group label="Titolo Query" label-class="small font-weight-bold text-uppercase text-muted">
								<b-form-input v-model="jsonData.title" placeholder="Es. Log Accessi"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col md="4">
							<b-form-group label="Datasource" label-class="small font-weight-bold text-uppercase text-muted">
								<b-form-select v-model="jsonData.idDatasource" :options="dataSourceOptions" size="lg" :value="null" value-field="id" text-field="datasourceName">
									<!-- <b-form-select-option v-for="ds in dataSourceOptions" :key="ds.id" :value="null" value-field="id" text-field="datasourceName">

									</b-form-select-option> -->
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row class="mb-4">
						<b-col cols="12">
							<b-form-group label="Descrizione" label-class="small font-weight-bold text-uppercase text-muted">
								<b-form-input v-model="jsonData.descrizione"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<div v-for="field in ['sqlGraphicQuery', 'sqlAnaliticQuery']" :key="field" class="mb-5">
						<div class="d-flex justify-content-between align-items-end mb-2">
							<label class="mb-0 font-weight-bold">
								<span v-if="field === 'sqlGraphicQuery'">📊 SQL GRAPHIC QUERY</span>
								<span v-else>🔍 SQL ANALITIC QUERY</span>
							</label>
							<b-button variant="outline-primary" class="px-3" @click="testQuery(field)" :disabled="!isValidSQL(jsonData[field])"> ▶ Esegui Test Query</b-button>
						</div>

						<div class="sa-dataanalysis-editor-container" :class="{ 'is-invalid-sql': !isValidSQL(jsonData[field]) }">
							<codemirror ref="myEditors" v-model="jsonData[field]" :options="cmOptions" @input="onCodeChange(field)"></codemirror>
						</div>

						<b-alert :show="!isValidSQL(jsonData[field])" variant="danger" class="mt-2 py-2 small"> <strong>Errore:</strong> Sono consentite solo query di tipo <code>SELECT</code>. </b-alert>
						<b-collapse :visible="!!testResults[field]" class="mt-3 shadow-sm rounded border overflow-hidden">
							<div class="bg-light px-3 py-2 border-bottom small font-weight-bold text-secondary">Anteprima Risultati (Simulazione)</div>
							<b-table v-if="testResults[field]" small hover striped responsive class="mb-0 sa-dataanalysis-table" :items="testResults[field].rows" :fields="testResults[field].columns"></b-table>
						</b-collapse>
					</div>
				</div>
			</div>
			<div class="sa-flexbox-footer"></div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
// Import obbligatori (Assicurati di avere codemirror@^5.65.13 installato)
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/mode/sql/sql.js";

export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	name: "DataAnalysisEditor",
	components: {
		codemirror,
	},
	data() {
		return {
			pathResource: "/dataanalysisquery",
			pathResourceDataSource: "/dataanalysisdatasources",
			dataSourceOptions: [],
			jsonData: { id: "-1", title: "", descrizione: "", idDatasource: null, sqlGraphicQuery: "", sqlAnaliticQuery: "" },
			// jsonData: {
			// 	id: "9e08265d-938e-4da0-a13a-218d1860df42",
			// 	title: "Query sui Log",
			// 	descrizione: "Query di test sulla tabella dei log",
			// 	idDatasource: "1",
			// 	sqlGraphicQuery: "SELECT id, sezione, username FROM gesan_security_log LIMIT 5",
			// 	sqlAnaliticQuery: "SELECT * FROM gesan_security_log WHERE stato = 'ERROR'",
			// },
			testResults: {
				sqlGraphicQuery: null,
				sqlAnaliticQuery: null,
			},
			cmOptions: {
				tabSize: 4,
				mode: "text/x-sql",
				theme: "dracula",
				lineNumbers: true,
				lineWrapping: true,
				viewportMargin: Infinity,
			},
		};
	},
	computed: {
		isFormValid() {
			return this.isValidSQL(this.jsonData.sqlGraphicQuery) && this.isValidSQL(this.jsonData.sqlAnaliticQuery) && this.jsonData.title.trim() !== "";
		},
	},
	mounted() {
		let me = this;
		me.id = this.$route.params.id;

		// Usiamo un piccolo timeout per essere sicuri che il layout sia stabile
		this.openShowModalLoading();
		setTimeout(() => {
			this.loadDataSourceData();
		}, 750);
	},
	watch: {
		// value: {
		// 	handler(newVal) {
		// 		this.jsonData = { ...newVal };
		// 		console.log(this.jsonData);
		// 	},
		// 	deep: true,
		// },
		jsonData: {
			handler(value) {
				this.$emit("updateJsonData", value);
			},
			deep: true,
		},
	},
	methods: {
		loadData() {
			let me = this;
			if (me.id === "-1") {
				this.closeShowModalLoading();
			} else {
				let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
				axios.get(link + me.id).then((response) => {
					me.jsonData = response.data.data;
					this.closeShowModalLoading();
				});
			}
		},
		loadDataSourceData() {
			let me = this;

			let link = process.env.VUE_APP_PATH_API + me.pathResourceDataSource;
			axios.get(link).then((response) => {
				me.dataSourceOptions = response.data.data.list;
				me.dataSourceOptions.unshift({ id: null, datasourceName: "-Selezionare un Datasource-" });
				this.refreshAllEditors();
				me.loadData();
			});
		},
		refreshAllEditors() {
			console.log(this.$refs.myEditors);
			if (this.$refs.myEditors && Array.isArray(this.$refs.myEditors)) {
				this.$refs.myEditors.forEach((editorComponent) => {
					// Verifichiamo che l'istanza interna di CodeMirror esista
					if (editorComponent && editorComponent.codemirror) {
						editorComponent.codemirror.refresh();
					}
				});
			}
		},
		isValidSQL(sql) {
			if (!sql) return false;
			const forbiddenKeywords = /\b(INSERT|UPDATE|DELETE|DROP|ALTER|TRUNCATE|CREATE|GRANT|REVOKE)\b/i;
			const hasSelect = /\bSELECT\b/i.test(sql);
			return hasSelect && !forbiddenKeywords.test(sql);
		},
		onCodeChange(field) {
			this.testResults[field] = null;
		},
		testQuery(field) {
			// 1. Reset immediato per "pulire" lo stato precedente
			this.$set(this.testResults, field, null);

			const mockData = {
				columns: ["id", "sezione", "username", "data_ora", "stato"],
				rows: [
					{ id: "101", sezione: "LOG", username: "admin", data_ora: "2026-01-23 10:00", stato: "OK" },
					{ id: "102", sezione: "SEC", username: "user1", data_ora: "2026-01-23 10:05", stato: "WARN" },
				],
			};

			// 2. Usa un micro-timeout per forzare il rendering se il reset non bastasse
			this.$nextTick(() => {
				this.$set(this.testResults, field, mockData);
			});
		},
	},
};
</script>

<style scoped>
.sa-dataanalysis-container {
	padding: 20px;
	background-color: #f8f9fa;
	min-height: 100vh;
}
.sa-dataanalysis-card {
	max-width: 900px;
	margin: 0 auto;
	background: white;
	padding: 30px;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.sa-dataanalysis-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 2px solid #f1f1f1;
	margin-bottom: 0px;
	padding-bottom: 5px;
}
.sa-dataanalysis-title {
	margin: 0;
	color: #2c3e50;
}
.sa-dataanalysis-id-badge {
	font-size: 0.75rem;
	background: #eee;
	padding: 4px 10px;
	border-radius: 15px;
	color: #666;
}
.sa-dataanalysis-row {
	display: flex;
	gap: 20px;
	margin-bottom: 20px;
}
.sa-dataanalysis-flex-2 {
	flex: 2;
}
.sa-dataanalysis-flex-1 {
	flex: 1;
}
.sa-dataanalysis-group {
	margin-bottom: 20px;
}
.sa-dataanalysis-label {
	display: block;
	font-weight: 600;
	font-size: 0.85rem;
	color: #4a5568;
	margin-bottom: 8px;
	text-transform: uppercase;
}
.sa-dataanalysis-input {
	width: 100%;
	padding: 10px;
	border: 1px solid #cbd5e0;
	border-radius: 6px;
	font-size: 0.95rem;
}
.sa-dataanalysis-sql-section {
	margin-top: 30px;
}
.sa-dataanalysis-sql-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}
.sa-dataanalysis-editor-wrapper {
	border-radius: 8px;
	border: 1px solid #cbd5e0;
	overflow: hidden;
}
.sa-dataanalysis-error-border {
	border-color: #e53e3e;
}
.sa-dataanalysis-container >>> .CodeMirror {
	height: 180px;
	font-family: "Fira Code", monospace;
	font-size: 14px;
}
.sa-dataanalysis-error-msg {
	color: #e53e3e;
	font-size: 0.8rem;
	margin-top: 8px;
	font-weight: bold;
}
.sa-dataanalysis-results {
	margin-top: 15px;
	background: #fdfdfd;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
}
.sa-dataanalysis-results-header {
	background: #edf2f7;
	padding: 8px 15px;
	font-size: 0.75rem;
	font-weight: bold;
	color: #4a5568;
}
.sa-dataanalysis-table-scroll {
	overflow-x: auto;
}
.sa-dataanalysis-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.85rem;
}
.sa-dataanalysis-table th {
	padding: 10px;
	background: #f8fafc;
	text-align: left;
	border-bottom: 1px solid #e2e8f0;
	color: #718096;
}
.sa-dataanalysis-table td {
	padding: 10px;
	border-bottom: 1px solid #edf2f7;
}
.sa-dataanalysis-footer {
	margin-top: 40px;
	padding-top: 20px;
	border-top: 1px solid #eee;
	text-align: right;
}
.sa-dataanalysis-btn-test {
	background: #ebf8ff;
	color: #3182ce;
	border: 1px solid #bee3f8;
	padding: 6px 15px;
	border-radius: 4px;
	cursor: pointer;
	font-weight: 600;
}
.sa-dataanalysis-btn-save {
	background: #48bb78;
	color: white;
	padding: 12px 40px;
	border: none;
	border-radius: 6px;
	cursor: pointer;
	font-weight: bold;
	font-size: 1rem;
}
.sa-dataanalysis-btn-save:disabled {
	background: #cbd5e0;
	cursor: not-allowed;
}
.sa-dataanalysis-editor-container {
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #dcdde1;
	margin-bottom: 10px;
}
.CodeMirror pre.CodeMirror-line,
.CodeMirror pre.CodeMirror-line-like {
	padding: 0 40px !important;
}
@media (max-width: 600px) {
	.sa-dataanalysis-row {
		flex-direction: column;
		gap: 0;
	}
}
</style>
